import React, { useState, useEffect } from 'react';
import api from '../services/api';

const STATUS_OPTIES = ['aangevraagd','bevestigd','geleverd','geannuleerd','afgerekend'];
const STATUS_COLORS = { aangevraagd:'#fbbf24', bevestigd:'#10b981', geleverd:'#3b82f6', geannuleerd:'#ef4444', afgerekend:'#6b7280' };
const STATUS_ICONS  = { aangevraagd:'🤝', bevestigd:'✅', geleverd:'📦', geannuleerd:'❌', afgerekend:'💰' };
const TYPE_OPTIES = [
  { value:'mens',      label:'👷 Mens' },
  { value:'materieel', label:'🛠️ Materieel' },
  { value:'dienst',    label:'📋 Dienst' }
];

function getWeekStartEnd(offset) {
  const d = new Date();
  d.setHours(0,0,0,0);
  const day = d.getDay() || 7;
  d.setDate(d.getDate() - day + 1 + offset * 7);
  const monday = new Date(d);
  const sunday = new Date(d); sunday.setDate(d.getDate() + 6); sunday.setHours(23,59,59,999);
  const thursday = new Date(d); thursday.setDate(d.getDate() + 3);
  const yearStart = new Date(thursday.getFullYear(), 0, 1);
  const weekNum = Math.ceil((((thursday - yearStart) / 86400000) + 1) / 7);
  const fmt = (x) => x.toLocaleDateString('nl-NL', { day:'numeric', month:'short' });
  return { start: monday, end: sunday, num: weekNum, label: 'Week ' + weekNum + ' (' + fmt(monday) + ' – ' + fmt(sunday) + ')' };
}

export default function Inhuur() {
  const [tab, setTab] = useState('bestellingen');
  const [resources, setResources] = useState([]);
  const [bestellingen, setBestellingen] = useState([]);
  const [afdelingen, setAfdelingen] = useState([]);
  const [monteurs, setMonteurs] = useState([]);
  const [alleGebruikers, setAlleGebruikers] = useState([]);
  const [werkorders, setWerkorders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterAfdeling, setFilterAfdeling] = useState('');
  const [weekOffset, setWeekOffset] = useState(0);

  const [showResourceModal, setShowResourceModal] = useState(false);
  const [resourceForm, setResourceForm] = useState(null);
  const [showBestelModal, setShowBestelModal] = useState(false);
  const [bestelForm, setBestelForm] = useState(null);
  const [mailConfirm, setMailConfirm] = useState(null);

  useEffect(() => { loadAll(); }, []);

  async function loadAll() {
    setLoading(true); setError('');
    try {
      const [r1, r2, r3, r4, r5] = await Promise.all([
        api.get('/inhuur/resources'),
        api.get('/inhuur/bestellingen'),
        api.get('/afdelingen').catch(()=>({data:[]})),
        api.get('/gebruikers').catch(()=>({data:[]})),
        api.get('/werkorders').catch(()=>({data:[]}))
      ]);
      setResources(r1.data || []);
      setBestellingen(r2.data || []);
      setAfdelingen(Array.isArray(r3.data) ? r3.data : (r3.data.afdelingen || []));
      const allUsers = Array.isArray(r4.data) ? r4.data : (r4.data.gebruikers || r4.data.data || []);
      setAlleGebruikers(allUsers);
      setMonteurs(allUsers.filter(u => u.in_planning));
      const allWO = Array.isArray(r5.data) ? r5.data : (r5.data.werkorders || r5.data.data || []);
      setWerkorders(allWO);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally { setLoading(false); }
  }

  function openNewResource() {
    setResourceForm({ naam:'', type:'mens', afdeling_id:'', leverancier:'', bestel_email:'', bestel_email_cc:'', eenheid:'dag', default_kosten:'', kleur:'#f59e0b', notities:'', verzendmodus:'direct', bundel_lead_weken:2, bundel_dag_van_week:1 });
    setShowResourceModal(true);
  }
  function openEditResource(r) {
    setResourceForm({ ...r,
      afdeling_id: r.afdeling_id || '', leverancier: r.leverancier || '',
      bestel_email: r.bestel_email || '', bestel_email_cc: r.bestel_email_cc || '',
      default_kosten: r.default_kosten || '', notities: r.notities || '' });
    setShowResourceModal(true);
  }
  async function saveResource() {
    if (!resourceForm.naam) { alert('Naam verplicht'); return; }
    try {
      const payload = { ...resourceForm,
        afdeling_id: resourceForm.afdeling_id || null,
        default_kosten: resourceForm.default_kosten ? parseFloat(resourceForm.default_kosten) : null };
      if (resourceForm.id) await api.put('/inhuur/resources/' + resourceForm.id, payload);
      else await api.post('/inhuur/resources', payload);
      setShowResourceModal(false); loadAll();
    } catch (e) { alert(e.response?.data?.error || e.message); }
  }
  async function verstuurBundelNu(id) {
    if (!window.confirm('Bundle nu versturen voor deze resource?')) return;
    try {
      const r = await api.post('/inhuur/bundle/verstuur-nu/' + id);
      if (r.data.skipped) alert('Niets verzonden: ' + r.data.reason);
      else if (r.data.error) alert('Fout: ' + r.data.error);
      else alert('✅ Bundle verzonden: ' + r.data.aantal_verzonden + ' aanvragen naar ' + r.data.naar);
      loadAll();
    } catch (e) {
      alert(e.response?.data?.error || e.message);
    }
  }

  async function deleteResource(id) {
    if (!window.confirm('Resource deactiveren?')) return;
    try { await api.delete('/inhuur/resources/' + id); loadAll(); }
    catch (e) { alert(e.response?.data?.error || e.message); }
  }

  function openNewBestel() {
    const t = new Date().toISOString().slice(0,10);
    setBestelForm({ resource_id:'', afdeling_id:'', werkorder_id:'', gekoppeld_monteur_id:'', contactpersoon_id:'', specificatie:'', datum_van:t, datum_tot:t, aantal:1, leverancier_override:'', kosten:'', ordernummer:'', opmerking:'' });
    setShowBestelModal(true);
  }
  function openEditBestel(b) {
    setBestelForm({ ...b,
      datum_van:(b.datum_van||'').toString().slice(0,10),
      datum_tot:(b.datum_tot||'').toString().slice(0,10),
      afdeling_id: b.afdeling_id || '', werkorder_id: b.werkorder_id || '',
      gekoppeld_monteur_id: b.gekoppeld_monteur_id || '',
      contactpersoon_id: b.contactpersoon_id || '',
      specificatie: b.specificatie || '',
      leverancier_override: b.leverancier_override || '',
      kosten: b.kosten || '', ordernummer: b.ordernummer || '', opmerking: b.opmerking || '' });
    setShowBestelModal(true);
  }
  async function saveBestel() {
    if (!bestelForm.resource_id || !bestelForm.datum_van || !bestelForm.datum_tot) { alert('Resource + beide datums verplicht'); return; }
    try {
      const payload = { ...bestelForm,
        resource_id: parseInt(bestelForm.resource_id),
        afdeling_id: bestelForm.afdeling_id || null,
        werkorder_id: bestelForm.werkorder_id || null,
        gekoppeld_monteur_id: bestelForm.gekoppeld_monteur_id || null,
        contactpersoon_id: bestelForm.contactpersoon_id || null,
        specificatie: bestelForm.specificatie || null,
        aantal: parseInt(bestelForm.aantal) || 1,
        kosten: bestelForm.kosten ? parseFloat(bestelForm.kosten) : null };
      if (bestelForm.id) await api.put('/inhuur/bestellingen/' + bestelForm.id, payload);
      else await api.post('/inhuur/bestellingen', payload);
      setShowBestelModal(false); loadAll();
    } catch (e) { alert(e.response?.data?.error || e.message); }
  }
  async function deleteBestel(id) {
    if (!window.confirm('Bestelling verwijderen?')) return;
    try { await api.delete('/inhuur/bestellingen/' + id); loadAll(); }
    catch (e) { alert(e.response?.data?.error || e.message); }
  }
  async function updateStatus(b, newStatus) {
    try { await api.put('/inhuur/bestellingen/' + b.id, { status: newStatus }); loadAll(); }
    catch (e) { alert(e.response?.data?.error || e.message); }
  }
  async function verstuurMail(b) {
    try {
      const res = await api.post('/inhuur/bestellingen/' + b.id + '/verstuur-email');
      alert('Mail verzonden naar ' + res.data.naar + (res.data.cc?.length ? ' (cc: ' + res.data.cc.join(', ') + ')' : ''));
      setMailConfirm(null); loadAll();
    } catch (e) { alert(e.response?.data?.error || e.message); }
  }

  const wk = getWeekStartEnd(weekOffset);
  const wkStart = wk.start.getTime();
  const wkEnd = wk.end.getTime();
  const wkLabel = wk.label;

  const filteredBest = bestellingen.filter(b => {
    if (filterStatus && b.status !== filterStatus) return false;
    if (filterAfdeling && String(b.afdeling_id) !== String(filterAfdeling)) return false;
    if (new Date(b.datum_van).getTime() > wkEnd) return false;
    if (new Date(b.datum_tot).getTime() < wkStart) return false;
    return true;
  }).sort((a, b) => new Date(a.datum_van) - new Date(b.datum_van));

  if (loading) return <div style={{padding:20}}>Laden...</div>;

  return (
    <div style={{padding:20, maxWidth:1400, margin:'0 auto'}}>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16}}>
        <h1 style={{margin:0}}>🤝 Inhuur</h1>
        <div>
          {tab==='bestellingen' && <button onClick={openNewBestel} style={btnPrimary}>+ Nieuwe bestelling</button>}
          {tab==='catalogus' && <button onClick={openNewResource} style={btnPrimary}>+ Nieuwe resource</button>}
        </div>
      </div>

      {error && <div style={{padding:10, background:'#fee2e2', border:'1px solid #ef4444', borderRadius:6, marginBottom:12}}>⚠️ {error}</div>}

      <div style={{display:'flex', gap:4, borderBottom:'2px solid #e5e7eb', marginBottom:16}}>
        <button onClick={()=>setTab('bestellingen')} style={tabBtn(tab==='bestellingen')}>📋 Bestellingen ({bestellingen.length})</button>
        <button onClick={()=>setTab('catalogus')}    style={tabBtn(tab==='catalogus')}>📚 Catalogus ({resources.length})</button>
      </div>

      {tab==='bestellingen' && (
        <>
          <div style={{display:'flex', gap:12, marginBottom:12, alignItems:'center'}}>
            <label>Status:&nbsp;
              <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={selectStyle}>
                <option value="">Alle</option>
                {STATUS_OPTIES.map(s=><option key={s} value={s}>{(STATUS_ICONS[s]||'')+' '+s}</option>)}
              </select>
            </label>
            <label>Afdeling:&nbsp;
              <select value={filterAfdeling} onChange={e=>setFilterAfdeling(e.target.value)} style={selectStyle}>
                <option value="">Alle</option>
                {afdelingen.map(a=><option key={a.id} value={a.id}>{a.naam}</option>)}
              </select>
            </label>
            <div style={{flex:1}}/>
            <span style={{color:'#6b7280'}}>{filteredBest.length} bestelling{filteredBest.length===1?'':'en'} in deze week</span>
          </div>
          <div style={{display:'flex', alignItems:'center', justifyContent:'center', gap:10, marginBottom:14, padding:'10px 12px', background:'#f9fafb', borderRadius:8, border:'1px solid #e5e7eb'}}>
            <button onClick={()=>setWeekOffset(weekOffset-1)} style={{padding:'6px 14px', background:'#fff', border:'1px solid #d1d5db', borderRadius:6, cursor:'pointer', fontSize:13}}>← Vorige week</button>
            <div style={{minWidth:300, textAlign:'center', padding:'8px 16px', background:'#eff6ff', borderRadius:6, fontWeight:700, color:'#1e3a5f', border:'1px solid #c7d2fe'}}>
              📅 {wkLabel}
            </div>
            <button onClick={()=>setWeekOffset(weekOffset+1)} style={{padding:'6px 14px', background:'#fff', border:'1px solid #d1d5db', borderRadius:6, cursor:'pointer', fontSize:13}}>Volgende week →</button>
            {weekOffset !== 0 ? <button onClick={()=>setWeekOffset(0)} style={{padding:'6px 14px', border:'1px solid #d1d5db', borderRadius:6, cursor:'pointer', fontSize:13, background:'#fef3c7', borderColor:'#f59e0b'}}>↺ Vandaag</button> : null}
          </div>
          <table style={tableStyle}>
            <thead><tr>
              <th style={th}>ID</th><th style={th}>Resource</th><th style={th}>Datum</th>
              <th style={th}>Aantal</th><th style={th}>Afdeling</th><th style={th}>Monteur</th>
              <th style={th}>Werkorder</th><th style={th}>Status</th><th style={th}>Reactie</th><th style={th}>Mail</th>
              <th style={th}>Acties</th>
            </tr></thead>
            <tbody>
              {filteredBest.map(b => (
                <tr key={b.id}>
                  <td style={td}>{b.id}</td>
                  <td style={td}>
                    <span style={{display:'inline-block', width:10, height:10, background:b.resource_kleur, borderRadius:'50%', marginRight:6, verticalAlign:'middle'}}/>
                    <strong>{b.resource_naam}</strong>
                    {b.resource_leverancier && <div style={{fontSize:11, color:'#6b7280'}}>{b.resource_leverancier}</div>}
                    {b.specificatie && <div style={{fontSize:11, color:'#92400e', fontWeight:600}}>↳ {b.specificatie}</div>}
                  </td>
                  <td style={td}>
                    {fmtDate(b.datum_van)}
                    {b.datum_van !== b.datum_tot && <><br/><span style={{color:'#6b7280', fontSize:12}}>t/m {fmtDate(b.datum_tot)}</span></>}
                  </td>
                  <td style={td}>{b.aantal}</td>
                  <td style={td}>{b.afdeling_naam || '-'}</td>
                  <td style={td}>{b.monteur_naam || <span style={{color:'#9ca3af'}}>-</span>}</td>
                  <td style={td}>{b.werkorder_id ? <>#{b.werkorder_id}{b.werkorder_titel && <div style={{fontSize:11, color:'#6b7280'}}>{b.werkorder_titel}</div>}</> : '-'}</td>
                  <td style={td}>
                    <select value={b.status} onChange={e=>updateStatus(b, e.target.value)}
                      style={{...selectStyle, background:STATUS_COLORS[b.status]+'22', borderColor:STATUS_COLORS[b.status]}}>
                      {STATUS_OPTIES.map(s=><option key={s} value={s}>{(STATUS_ICONS[s]||'')+' '+s}</option>)}
                    </select>
                  </td>
                  <td style={td}>
                    {b.response_actie
                      ? <span title={'Gereageerd: ' + new Date(b.response_op).toLocaleString('nl-NL') + (b.response_reden ? '\n\nReden: ' + b.response_reden : '')} style={{cursor:'help'}}>
                          {b.response_actie === 'bevestigd' ? '✅' : '❌'}{' '}
                          <span style={{fontSize:11, color:'#6b7280'}}>{new Date(b.response_op).toLocaleDateString('nl-NL', {day:'numeric', month:'short'})}</span>
                          {b.response_reden && <div style={{fontSize:10, color:'#9ca3af', fontStyle:'italic', maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}} title={b.response_reden}>"{b.response_reden}"</div>}
                        </span>
                      : (b.email_verzonden_op
                          ? <span style={{color:'#9ca3af', fontSize:11}} title="Wacht op reactie">⏳ wacht</span>
                          : <span style={{color:'#d1d5db', fontSize:11}}>-</span>)}
                  </td>
                  <td style={td}>
                    {b.email_verzonden_op
                      ? <span title={'Verzonden ' + fmtDate(b.email_verzonden_op) + ' naar ' + (b.email_verzonden_naar||'')}>✉️ verzonden</span>
                      : b.bundel_pending
                        ? <span style={{color:'#92400e', fontSize:11, fontWeight:600}} title="Wacht op volgende bundle-mail">📦 in bundle</span>
                        : (b.resource_bestel_email
                            ? <button onClick={()=>setMailConfirm(b)} style={btnSmall}>📧 Verstuur</button>
                            : <span style={{color:'#9ca3af', fontSize:11}}>geen e-mail</span>)}
                  </td>
                  <td style={td}>
                    <button onClick={()=>openEditBestel(b)} style={btnSmall}>✏️</button>
                    <button onClick={()=>deleteBestel(b.id)} style={{...btnSmall, color:'#ef4444'}}>🗑️</button>
                  </td>
                </tr>
              ))}
              {filteredBest.length===0 && <tr><td colSpan={11} style={{...td, textAlign:'center', color:'#9ca3af', padding:30}}>Geen bestellingen</td></tr>}
            </tbody>
          </table>
        </>
      )}

      {tab==='catalogus' && (
        <table style={tableStyle}>
          <thead><tr>
            <th style={th}></th><th style={th}>Naam</th><th style={th}>Type</th>
            <th style={th}>Afdeling</th><th style={th}>Leverancier</th><th style={th}>Bestel-mail</th>
            <th style={th}>Eenheid</th><th style={th}>Verzending</th><th style={th}>Std kosten</th><th style={th}>Acties</th>
          </tr></thead>
          <tbody>
            {resources.map(r => (
              <tr key={r.id}>
                <td style={td}><span style={{display:'inline-block', width:14, height:14, background:r.kleur, borderRadius:4}}/></td>
                <td style={td}><strong>{r.naam}</strong></td>
                <td style={td}>{TYPE_OPTIES.find(t=>t.value===r.type)?.label || r.type}</td>
                <td style={td}>{r.afdeling_naam || <span style={{color:'#9ca3af'}}>alle</span>}</td>
                <td style={td}>{r.leverancier || '-'}</td>
                <td style={td}>{r.bestel_email || <span style={{color:'#9ca3af', fontSize:11}}>niet ingesteld</span>}</td>
                <td style={td}>{r.eenheid}</td>
                <td style={td}>
                  {r.verzendmodus === 'bundel' ? (
                    <div>
                      <div style={{fontSize:11, color:'#92400e', fontWeight:600}}>📦 Week +{r.bundel_lead_weken || 2} op {['ma','di','wo','do','vr','za','zo'][(r.bundel_dag_van_week || 1) - 1]}</div>
                      <button onClick={()=>verstuurBundelNu(r.id)} style={{...btnSmall, marginTop:4, background:'#f59e0b', color:'#fff', border:'none'}}>📨 Nu versturen</button>
                    </div>
                  ) : <span style={{color:'#6b7280', fontSize:11}}>direct</span>}
                </td>
                <td style={td}>{r.default_kosten ? '€ ' + r.default_kosten : '-'}</td>
                <td style={td}>
                  <button onClick={()=>openEditResource(r)} style={btnSmall}>✏️</button>
                  <button onClick={()=>deleteResource(r.id)} style={{...btnSmall, color:'#ef4444'}}>🗑️</button>
                </td>
              </tr>
            ))}
            {resources.length===0 && <tr><td colSpan={10} style={{...td, textAlign:'center', color:'#9ca3af', padding:30}}>Geen resources — voeg er een toe</td></tr>}
          </tbody>
        </table>
      )}

      {showResourceModal && resourceForm && (
        <Modal onClose={()=>setShowResourceModal(false)} title={resourceForm.id ? 'Resource bewerken' : 'Nieuwe resource'}>
          <Field label="Naam *"><input value={resourceForm.naam} onChange={e=>setResourceForm({...resourceForm, naam:e.target.value})} style={inputStyle}/></Field>
          <Field label="Type">
            <select value={resourceForm.type} onChange={e=>setResourceForm({...resourceForm, type:e.target.value})} style={inputStyle}>
              {TYPE_OPTIES.map(t=><option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
          </Field>
          <Field label="Afdeling (leeg = alle)">
            <select value={resourceForm.afdeling_id} onChange={e=>setResourceForm({...resourceForm, afdeling_id:e.target.value})} style={inputStyle}>
              <option value="">— alle afdelingen —</option>
              {afdelingen.map(a=><option key={a.id} value={a.id}>{a.naam}</option>)}
            </select>
          </Field>
          <Field label="Leverancier"><input value={resourceForm.leverancier} onChange={e=>setResourceForm({...resourceForm, leverancier:e.target.value})} style={inputStyle}/></Field>
          <Field label="Bestel-email (waar mail heen gaat)"><input type="email" value={resourceForm.bestel_email} onChange={e=>setResourceForm({...resourceForm, bestel_email:e.target.value})} style={inputStyle} placeholder="bv. planning@leverancier.nl"/></Field>
          <Field label="CC email(s)"><input value={resourceForm.bestel_email_cc} onChange={e=>setResourceForm({...resourceForm, bestel_email_cc:e.target.value})} style={inputStyle} placeholder="komma-gescheiden"/></Field>
          <div style={{display:'flex', gap:12}}>
            <Field label="Eenheid">
              <select value={resourceForm.eenheid} onChange={e=>setResourceForm({...resourceForm, eenheid:e.target.value})} style={inputStyle}>
                <option value="dag">dag</option><option value="uur">uur</option><option value="stuk">stuk</option>
              </select>
            </Field>
            <Field label="Std. kosten"><input type="number" step="0.01" value={resourceForm.default_kosten} onChange={e=>setResourceForm({...resourceForm, default_kosten:e.target.value})} style={inputStyle}/></Field>
            <Field label="Kleur"><input type="color" value={resourceForm.kleur} onChange={e=>setResourceForm({...resourceForm, kleur:e.target.value})} style={{...inputStyle, padding:2, height:36}}/></Field>
          </div>
          <Field label="Specificatie-label (toont extra veld in bestelling, bv. 'Naam monteur')">
            <input value={resourceForm.specificatie_label || ''} onChange={e=>setResourceForm({...resourceForm, specificatie_label:e.target.value})} style={inputStyle} placeholder="Leeg = geen extra veld"/>
          </Field>
          <Field label="Specificatie-opties (komma-gescheiden → dropdown, leeg → tekstveld)">
            <input value={resourceForm.specificatie_opties || ''} onChange={e=>setResourceForm({...resourceForm, specificatie_opties:e.target.value})} style={inputStyle} placeholder="Bv. Jan de Vries, Piet Janssen, Mohammed El-Bakri"/>
          </Field>
          <div style={{display:'flex', gap:12, padding:12, background:'#fff7ed', borderRadius:6, marginBottom:12, border:'1px dashed #f59e0b', flexWrap:'wrap'}}>
            <Field label="📨 Verzendmodus">
              <select value={resourceForm.verzendmodus || 'direct'} onChange={e=>setResourceForm({...resourceForm, verzendmodus:e.target.value})} style={inputStyle}>
                <option value="direct">Direct (per aanvraag een mail)</option>
                <option value="bundel">Bundel (1× per week voor week +N)</option>
              </select>
            </Field>
            {resourceForm.verzendmodus === 'bundel' && (<>
              <Field label="📅 Lead-weken">
                <input type="number" min="1" max="8" value={resourceForm.bundel_lead_weken || 2} onChange={e=>setResourceForm({...resourceForm, bundel_lead_weken:e.target.value})} style={inputStyle} placeholder="2"/>
              </Field>
              <Field label="🗓️ Verstuurdag">
                <select value={resourceForm.bundel_dag_van_week || 1} onChange={e=>setResourceForm({...resourceForm, bundel_dag_van_week:Number(e.target.value)})} style={inputStyle}>
                  <option value={1}>Maandag</option>
                  <option value={2}>Dinsdag</option>
                  <option value={3}>Woensdag</option>
                  <option value={4}>Donderdag</option>
                  <option value={5}>Vrijdag</option>
                  <option value={6}>Zaterdag</option>
                  <option value={7}>Zondag</option>
                </select>
              </Field>
            </>)}
          </div>
          <Field label="Notities"><textarea rows={3} value={resourceForm.notities} onChange={e=>setResourceForm({...resourceForm, notities:e.target.value})} style={inputStyle}/></Field>
          <div style={{textAlign:'right', marginTop:16}}>
            <button onClick={()=>setShowResourceModal(false)} style={btnSecondary}>Annuleren</button>
            <button onClick={saveResource} style={btnPrimary}>Opslaan</button>
          </div>
        </Modal>
      )}

      {showBestelModal && bestelForm && (
        <Modal onClose={()=>setShowBestelModal(false)} title={bestelForm.id ? 'Bestelling bewerken' : 'Nieuwe bestelling'}>
          <Field label="Resource *">
            <select value={bestelForm.resource_id} onChange={e=>setBestelForm({...bestelForm, resource_id:e.target.value, specificatie:''})} style={inputStyle}>
              <option value="">— kies —</option>
              {resources.map(r=><option key={r.id} value={r.id}>{r.naam}{r.leverancier?' ('+r.leverancier+')':''}</option>)}
            </select>
          </Field>
          {(() => {
            const selRes = resources.find(r => String(r.id) === String(bestelForm.resource_id));
            if (!selRes || !selRes.specificatie_label) return null;
            const opties = (selRes.specificatie_opties || '').split(',').map(s=>s.trim()).filter(Boolean);
            return (
              <Field label={selRes.specificatie_label + (opties.length ? ' (kies uit lijst)' : '')}>
                {opties.length > 0 ? (
                  <select value={bestelForm.specificatie} onChange={e=>setBestelForm({...bestelForm, specificatie:e.target.value})} style={inputStyle}>
                    <option value="">— kies —</option>
                    {opties.map(o => <option key={o} value={o}>{o}</option>)}
                  </select>
                ) : (
                  <input value={bestelForm.specificatie} onChange={e=>setBestelForm({...bestelForm, specificatie:e.target.value})} style={inputStyle} placeholder={'Bv. ' + selRes.specificatie_label}/>
                )}
              </Field>
            );
          })()}
          <div style={{display:'flex', gap:12}}>
            <Field label="Datum van *"><input type="date" value={bestelForm.datum_van} onChange={e=>setBestelForm({...bestelForm, datum_van:e.target.value})} style={inputStyle}/></Field>
            <Field label="Datum tot *"><input type="date" value={bestelForm.datum_tot} onChange={e=>setBestelForm({...bestelForm, datum_tot:e.target.value})} style={inputStyle}/></Field>
            <Field label="Aantal"><input type="number" min="1" value={bestelForm.aantal} onChange={e=>setBestelForm({...bestelForm, aantal:e.target.value})} style={inputStyle}/></Field>
          </div>
          <Field label="Afdeling">
            <select value={bestelForm.afdeling_id} onChange={e=>setBestelForm({...bestelForm, afdeling_id:e.target.value})} style={inputStyle}>
              <option value="">— mijn afdeling —</option>
              {afdelingen.map(a=><option key={a.id} value={a.id}>{a.naam}</option>)}
            </select>
          </Field>
          <Field label="Koppel aan monteur (toont badge in planning)">
            <select value={bestelForm.gekoppeld_monteur_id} onChange={e=>setBestelForm({...bestelForm, gekoppeld_monteur_id:e.target.value})} style={inputStyle}>
              <option value="">— geen —</option>
              {monteurs.map(m=><option key={m.id} value={m.id}>{m.voornaam} {m.achternaam}</option>)}
            </select>
          </Field>
          <Field label="Werkvoorbereider / contactpersoon voor leverancier (ontvangt mail-replies)">
            <select value={bestelForm.contactpersoon_id} onChange={e=>setBestelForm({...bestelForm, contactpersoon_id:e.target.value})} style={inputStyle}>
              <option value="">— ikzelf (besteller) —</option>
              {alleGebruikers.map(g=><option key={g.id} value={g.id}>{g.voornaam} {g.achternaam}{g.email ? ' — ' + g.email : ''}</option>)}
            </select>
          </Field>
          <Field label="Koppel aan werkorder (optioneel)">
            <select value={bestelForm.werkorder_id} onChange={e=>setBestelForm({...bestelForm, werkorder_id:e.target.value})} style={inputStyle}>
              <option value="">— geen —</option>
              {werkorders.slice(0,150).map(w=><option key={w.id} value={w.id}>#{w.id} {w.titel}</option>)}
            </select>
          </Field>
          <div style={{display:'flex', gap:12}}>
            <Field label="Kosten"><input type="number" step="0.01" value={bestelForm.kosten} onChange={e=>setBestelForm({...bestelForm, kosten:e.target.value})} style={inputStyle}/></Field>
            <Field label="Ordernummer"><input value={bestelForm.ordernummer} onChange={e=>setBestelForm({...bestelForm, ordernummer:e.target.value})} style={inputStyle}/></Field>
          </div>
          <Field label="Leverancier override"><input value={bestelForm.leverancier_override} onChange={e=>setBestelForm({...bestelForm, leverancier_override:e.target.value})} style={inputStyle}/></Field>
          <Field label="Opmerking"><textarea rows={3} value={bestelForm.opmerking} onChange={e=>setBestelForm({...bestelForm, opmerking:e.target.value})} style={inputStyle}/></Field>
          <div style={{textAlign:'right', marginTop:16}}>
            <button onClick={()=>setShowBestelModal(false)} style={btnSecondary}>Annuleren</button>
            <button onClick={saveBestel} style={btnPrimary}>Opslaan</button>
          </div>
        </Modal>
      )}

      {mailConfirm && (
        <Modal onClose={()=>setMailConfirm(null)} title="Aanvraag verzenden">
          <p>Verzend inhuur-aanvraag voor <strong>{mailConfirm.resource_naam}</strong> naar <code>{mailConfirm.resource_bestel_email}</code>?</p>
          <p style={{color:'#6b7280', fontSize:13}}>Jij krijgt automatisch een CC.</p>
          <div style={{textAlign:'right', marginTop:16}}>
            <button onClick={()=>setMailConfirm(null)} style={btnSecondary}>Annuleren</button>
            <button onClick={()=>verstuurMail(mailConfirm)} style={btnPrimary}>📧 Verzend</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('nl-NL', { day:'numeric', month:'short', year:'numeric' });
}
function Field({label, children}) {
  return <div style={{marginBottom:12, flex:1}}><label style={{display:'block', fontSize:12, fontWeight:600, color:'#374151', marginBottom:4}}>{label}</label>{children}</div>;
}
function Modal({title, onClose, children}) {
  return (
    <div onClick={onClose} style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000}}>
      <div onClick={e=>e.stopPropagation()} style={{background:'#fff', padding:24, borderRadius:8, maxWidth:600, width:'90%', maxHeight:'90vh', overflowY:'auto'}}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16}}>
          <h2 style={{margin:0}}>{title}</h2>
          <button onClick={onClose} style={{background:'none', border:'none', fontSize:24, cursor:'pointer', color:'#6b7280'}}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

const tabBtn = active => ({padding:'10px 16px', background:active?'#3b82f6':'transparent', color:active?'#fff':'#374151', border:'none', borderRadius:'6px 6px 0 0', cursor:'pointer', fontWeight:600});
const btnPrimary = {padding:'8px 16px', background:'#3b82f6', color:'#fff', border:'none', borderRadius:6, cursor:'pointer', fontWeight:600, marginLeft:8};
const btnSecondary = {padding:'8px 16px', background:'#e5e7eb', color:'#111', border:'none', borderRadius:6, cursor:'pointer', marginLeft:8};
const btnSmall = {padding:'4px 8px', background:'#fff', border:'1px solid #d1d5db', borderRadius:4, cursor:'pointer', fontSize:12, marginRight:4};
const inputStyle = {width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:6, fontSize:14, boxSizing:'border-box'};
const selectStyle = {padding:'6px 10px', border:'1px solid #d1d5db', borderRadius:6, fontSize:13};
const tableStyle = {width:'100%', borderCollapse:'collapse', background:'#fff', borderRadius:8, overflow:'hidden', boxShadow:'0 1px 3px rgba(0,0,0,0.1)'};
const th = {padding:'10px', background:'#f9fafb', borderBottom:'2px solid #e5e7eb', textAlign:'left', fontSize:13, fontWeight:600};
const td = {padding:'10px', borderBottom:'1px solid #f3f4f6', fontSize:13, verticalAlign:'top'};
